import Fade from "react-reveal/Fade";

export default function SectionTwo() {
  const defaultClass = "flex my-auto justify-center";
  return (
    <div className="md:flex md:mb-0 mb-20 space-y-10">
      <div className={`md:w-5/12 ${defaultClass}`}>
        <Fade bottom>
          <img
            src={`${window.localhost}/img/imgsec2.jpg`}
            className="md:w-4/5 w-8/12"
            alt="Gambar section 2"
          />
        </Fade>
      </div>
      <div className={`md:w-7/12 ${defaultClass}`}>
        <div className="md:space-y-8 space-y-5">
          <Fade right>
            <h1 className="md:text-6xl text-4xl font-black">
              MENGAPA <span className="text-red-creatifa">LOGO</span> PENTING?
            </h1>

            <p className="text-xl">
              Identitas adalah hal yang paling esensial ketika ingin membangun
              sebuah bisnis. <b>LOGO</b> adalah elemen utama dalam membangun
              identitas tersebut. Salah satu cara membangun brand yang
              berkualitas adalah dengan menciptakan logo yang berkualitas juga.
              Karena logo adalah representasi visual yang akan membuat produk
              Anda menjadi lebih unik dan menarik. Dalam bidang pemasaran
              sendiri, logo berfungsi untuk memperkuat iklan dalam pengenalan
              produk kepada masyarakat.
            </p>
          </Fade>
        </div>
      </div>
    </div>
  );
}
